angular.module("warsApp.factories").factory('configurationInterceptor', ["$location", function ($location) {
    
    return {
        request: function (config) {
            if (config.method === "GET") return config;
            // Using a post for the get codes call
            if (config.url.indexOf("/api/Code/GetCodes") !== -1) return config;

            var absoluteUrl = $location.absUrl();
            if (absoluteUrl.match(/#\/ProcessConfiguration\/[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}\/Manage/)) {
                var firstGuidRegEx = /([a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12})/i;
                var match = firstGuidRegEx.exec(absoluteUrl);

                var processConfiguration = match ? match[1] : null;

                if (processConfiguration) {
                    config.headers["Wars-Configuration-Update"] = processConfiguration;
                }
            }

            return config;
        }
    };
}]);